import type { CityConfig } from "../city-template/types";

export const catskillConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Catskill",
  state: "New York",
  stateAbbr: "NY",
  slug: "catskill",
  route: "/cities/catskill",
  title: "Emergency Passport Catskill, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Catskill, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Catskill Mountain travelers, Greene County families, ski season Alps-bound residents, and Hudson River valley communities.",
  h1: "Emergency & Expedited Passport Services in Catskill, NY",
  heroSubtitle: "Catskill is the gateway to the Catskill Mountains — where ski season sends Hudson Valley residents to the Alps and summer brings international tourists to the peaks. Whether you're a Hunter Mountain skier heading to Switzerland, a Greene County family with a European vacation planned, or a Hudson River valley resident who just discovered an expired passport — Fast Passport Center delivers. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20Main%20Street%20of%20Catskill%20New%20York%20with%20the%20Catskill%20Creek%20bridge%20and%20charming%20village%20shops%2C%20gateway%20to%20the%20Catskill%20Mountains%20with%20dramatic%20green%20mountain%20peaks%20rising%20in%20the%20background%2C%20Greene%20County%20upstate%20New%20York%20landscape%2C%20warm%20golden%20afternoon%20light%20casting%20long%20shadows%20on%20brick%20storefronts%2C%20Catskill%20Mountain%20House%20history%20visible%20in%20the%20mountain%20silhouette%2C%20editorial%20travel%20photography%20with%20rich%20green%20and%20gold%20tones%2C%20clean%20composition%20with%20deep%20depth%20of%20field%2C%20no%20text%20overlay%2C%20nostalgic%20yet%20vibrant%20Hudson%20Valley%20mountain%20town%20scene&width=1600&height=700&seq=catskill-hero-2026-v2&orientation=landscape",
  heroImageAlt: "Historic Catskill New York Main Street with Catskill Mountains and Greene County landscape at golden hour",
  geoPosition: "42.2146;-73.8645",
  geoPlacename: "Catskill, New York",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "Located in Manhattan — approximately 100 miles from Catskill, appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Catskill", zips: "12414" },
    { name: "Cairo", zips: "12413" },
    { name: "Hunter", zips: "12442" },
    { name: "Windham", zips: "12496" },
    { name: "Tannersville", zips: "12485" },
    { name: "Palenville", zips: "12463" },
    { name: "Athens", zips: "12015" },
    { name: "Greenville", zips: "12083" },
    { name: "Saugerties", zips: "12477" },
    { name: "Woodstock", zips: "12498" },
    { name: "Hudson", zips: "12534" },
    { name: "Coxsackie", zips: "12051" },
    { name: "Albany", zips: "12201–12260" },
    { name: "Kingston", zips: "12401, 12402" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Catskill Mountain Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Catskill-area travelers with immediate departures from ALB, SWF, or JFK." },
    { icon: "ri-flight-takeoff-line", title: "ALB + SWF Dual-Airport Expertise", desc: "Albany International (50 miles) and Stewart International (45 miles) — two airports within an hour, each with different international connection patterns. We know both." },
    { icon: "ri-snowy-line", title: "Ski Season to Alps Travel Ready", desc: "Catskill Mountain skiers heading to the Alps need valid passports on short winter timelines. Hunter, Windham, and Belleayre skiers trust us for pre-season passport preparation." },
    { icon: "ri-landscape-line", title: "Greene County & Mountain Gateway", desc: "From the Hudson River at Catskill to the High Peaks at Hunter and Windham — we serve all of Greene County with understanding of mountain town travel patterns." },
  ],
  internalLinks: [
    { name: "Fast passport services in Albany, NY", route: "/cities/albany-ny" },
    { name: "Expedited passport in Hudson, NY", route: "/cities/hudson-ny" },
    { name: "Quick passport services in Kingston, NY", route: "/cities/kingston" },
    { name: "Urgent passport services in Rhinebeck, NY", route: "/cities/rhinebeck" },
    { name: "New York passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Catskill via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 100 miles to Manhattan. Catskill residents can ship from any UPS Store, FedEx Office, or post office location across Greene County.",
  fpcOfficeDistance: "Serving Catskill, Cairo, Hunter, Windham, Tannersville, and all Greene County and Catskill Mountain communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Catskill and the greater Greene County region. From the historic Catskill Creek waterfront to the ski slopes of Hunter and Windham Mountains, from the Rip Van Winkle Bridge to the mountain hamlets of Tannersville and Palenville — we serve all of Greene County. Our courier service eliminates the need to drive 100 miles to Manhattan and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve Catskill and all Greene County communities including Cairo, Hunter, Windham, Tannersville, Palenville, Athens, and Greenville. We also serve travelers departing from Albany International Airport, Stewart International Airport, and JFK who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Catskill as simple as possible — with the efficiency and reliability Greene County mountain residents and Hudson River valley families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Catskill travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Catskill travelers encounter unique passport issues — from ski-season-to-Alps timing to damaged passports from mountain activities. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Catskill travelers — from Hunter Mountain skiers to Cairo families to Windham weekenders — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Catskill, NY? Here are the most common ones we hear from Greene County travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before Alps ski season, an emergency passport for a last-minute JFK departure, or a first-time passport for a Greene County family — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins accepted", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "ALB connection to a European ski destination in three days? JFK departure this weekend? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Catskill-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Catskill residents renew fast — no agency visit required for most renewals. Perfect for Greene County skiers, mountain second-home owners, and Hudson River valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Catskill residents through every step — from the village to Cairo to Hunter — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your ALB connection or JFK international departure is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Greene County family ski trip to the Alps stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Catskill-area residents after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Catskill Mountain second-home owners and Greene County professionals who travel internationally while their primary passport processes a visa.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Catskill Mountain travelers through the process — especially those whose passports suffered water or snow damage from outdoor mountain activities.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Catskill NY", description: "Urgent passport processing for Catskill New York travelers with immediate departure needs from Albany International or Stewart." },
    { name: "Expedited Passport Renewal Catskill NY", description: "Fast passport renewal for Catskill New York residents with a previously-issued passport." },
    { name: "First-Time Passport Catskill NY", description: "New passport application services for Catskill New York residents applying for their first passport." },
    { name: "Child Passport Catskill NY", description: "Minor passport services for Catskill New York families with children under 16." },
    { name: "Name Change Passport Catskill NY", description: "Passport name correction after marriage, divorce, or legal name changes for Catskill residents." },
    { name: "Second Passport Catskill NY", description: "Second passport services for Catskill Mountain second-home owners and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Catskill, NY",
      rating: 5,
      text: "Had a ski trip to the Alps planned in 8 days. Fast Passport Center got my expedited passport processed in 4 days. I ski Hunter Mountain every weekend and the idea of driving to Manhattan for a passport was absurd — this remote service was perfect.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Michael B.",
      location: "Cairo, NY",
      rating: 5,
      text: "Renewed my passport for a summer trip to Ireland. Chose the 5-day option and had it back in 4. The process was seamless for someone living in a small Greene County town — no driving, no waiting, no stress.",
      service: "Passport Renewal",
    },
    {
      name: "Laura D.",
      location: "Hunter, NY",
      rating: 5,
      text: "First-time passport for my son's school trip to Quebec. Fast Passport Center guided us through the DS-11 and parental consent process from up in Hunter. The Catskill Post Office appointment was easy and everything was processed in 5 days.",
      service: "Child Passport",
    },
    {
      name: "James R.",
      location: "Windham, NY",
      rating: 5,
      text: "I own a ski condo at Windham and booked a last-minute trip to Zermatt. Discovered my passport had water damage from ski season. Fast Passport Center got a replacement in 4 days. They understood the urgency of ski season travel windows.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "catskill-1",
      name: "Catskill Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Jefferson Avenue",
      city: "Catskill",
      state: "NY",
      zip: "12414",
      phone: "(518) 943-3531",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Catskill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Catskill and Greene County. First-time applicants must appear in person. Saturday hours available — extremely popular during summer tourism and pre-ski season. Book at least two weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "catskill-2",
      name: "Hudson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "365 Fairview Avenue",
      city: "Hudson",
      state: "NY",
      zip: "12534",
      phone: "(518) 828-1575",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Hudson, approximately 12 miles from Catskill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Larger facility across the river in Columbia County. Good alternative for west Greene County residents. Passport photos available. Amtrak station nearby for combined passport-and-travel errands.",
      icon: "ri-mail-line",
    },
    {
      id: "catskill-3",
      name: "Cairo Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "351 Main Street",
      city: "Cairo",
      state: "NY",
      zip: "12413",
      phone: "(518) 622-8110",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Cairo, approximately 10 miles north of Catskill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Small facility serving Cairo, Greenville, and northern Greene County communities. Limited appointment slots — call well ahead during peak seasons. Convenient for Route 23 corridor residents.",
      icon: "ri-mail-line",
    },
    {
      id: "catskill-4",
      name: "Greene County Clerk — Catskill",
      type: "County Clerk Passport Acceptance",
      address: "411 Main Street",
      city: "Catskill",
      state: "NY",
      zip: "12414",
      phone: "(518) 719-3270",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Downtown Catskill — Greene County Office Building",
      website: "https://www.greenegovernment.com/departments/county-clerk",
      websiteLabel: "Greene County Clerk",
      notes: "County clerk passport acceptance services at the Greene County Office Building on Main Street. No photo services on-site — bring your own 2x2 photos. Walk-ins accepted but appointments strongly recommended.",
      icon: "ri-government-line",
    },
    {
      id: "catskill-5",
      name: "Saugerties Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "231 Main Street",
      city: "Saugerties",
      state: "NY",
      zip: "12477",
      phone: "(845) 246-9232",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Saugerties, approximately 12 miles from Catskill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for southern Greene County residents near the Ulster County border. Passport photos available. Popular with Saugerties and Woodstock area travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "catskill-6",
      name: "Albany Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "30 Karner Road",
      city: "Albany",
      state: "NY",
      zip: "12288",
      phone: "(518) 452-2285",
      hours: "Mon–Fri 8:00 AM – 6:00 PM, Sat 9:00 AM – 2:00 PM",
      distance: "Albany, approximately 35 miles from Catskill",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest nearby facility with extended weekday hours and Saturday afternoon availability. Full photo services on-site. Best fallback option when Greene County appointments are booked during peak seasons.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 100 miles to Manhattan", fpc: "Most Greene County travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Catskill-Specific Guidance", agency: "Generic — no ski season, Catskill Mountain, or Greene County expertise", fpc: "Full ski season/mountain town/ALB-SWF/Green County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Ski Season Passport Timing Gap",
      description: "Catskill Mountain skiers book Alps trips months in advance — often when Hunter and Windham season passes go on sale. Then they discover expired passports in November, weeks before December departures. We handle this compressed pre-season window every year.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Water-Damaged Passports from Mountain Activities",
      description: "Catskill hikers and skiers frequently damage passports with water, snow, and moisture. A water-damaged passport requires an in-person DS-11 replacement — not a simple renewal — adding time and complexity.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Catskill applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. In a mountain town with limited acceptance facility hours, a rejected form means another trip to the post office.",
    },
    {
      icon: "ri-error-warning-line",
      title: "ALB Domestic Connection Confusion",
      description: "Many Greene County travelers book domestic flights from ALB connecting to international hubs — without realizing they need a valid passport at check-in in Albany, not just at the international connection point.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Catskill travelers booking to Switzerland, Austria, France, and Italy for ski season often do not know the Schengen Area requires 3 months of passport validity beyond the planned departure date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home in Catskill or mountain condo in Hunter." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your ski season or summer travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Catskill clients ship from the Catskill Post Office on Jefferson Avenue — no Manhattan visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 100 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty for your travel from the Catskills." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Catskill?", a: "We offer Catskill-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Catskill office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Catskill, Hudson, or Cairo post office), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Catskill address." },
    { q: "Where can I get a passport acceptance in Catskill?", a: "Catskill has acceptance facilities at the Catskill Post Office (1 Jefferson Avenue), Greene County Clerk (411 Main Street), Hudson Post Office (365 Fairview Avenue), and Cairo Post Office (351 Main Street). The Albany Main Post Office offers extended hours for urgent needs." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, 100 miles from Catskill) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel." },
    { q: "What is the best price for expedited passport service in Catskill?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Can I get a passport before ski season in the Alps?", a: "Yes — this is one of our most common scenarios for Catskill Mountain residents. Ski season in the Alps typically runs December through April, and we recommend starting the passport process in September or October. For last-minute bookings in November, our 2–9 business day expedited service handles the compressed timeline." },
    { q: "What if my passport got water damaged on a hike?", a: "Water-damaged passports are defined as 'significantly damaged' by the State Department and require an in-person DS-11 application at an acceptance facility — you cannot use the mail-in DS-82 renewal form. We guide you through the full DS-11 process and expedite the replacement." },
    { q: "Can I get a passport photo in Catskill?", a: "Yes — the Catskill Post Office offers photo services on-site. CVS, Walgreens, and Rite Aid locations in Catskill and Hudson also offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What airports do Catskill travelers typically use?", a: "Catskill residents use Albany International (50 miles north), Stewart International (45 miles south near Newburgh), and JFK (100 miles south in Queens). ALB is most common for domestic connections to international hubs, while JFK serves direct international flights to Europe and beyond." },
    { q: "Can you help with passports for ski trips to Europe?", a: "Yes — we regularly assist Greene County skiers with expedited passports for trips to Switzerland, France, Austria, and Italy. We understand the ski season calendar and the fact that European ski resorts book up 6–12 months in advance, creating a gap between booking and passport checking." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Catskill Residents",
    intro: "Catskill's position as the gateway to the Catskill Mountains — with its ski culture, tourism economy, and 100-mile distance to the nearest passport agency — creates distinct seasonal passport challenges. Here's what Greene County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "50 miles north, Capital Region hub",
        description: "Albany International is the closest major airport for Greene County travelers, serving domestic flights and connections to international hubs like JFK, EWR, Atlanta, Chicago, and Detroit. For Catskill residents, this means most international travel starts with a domestic connection. The 50-mile drive on Route 9W and I-87 takes about an hour. Passport validity is required at check-in in Albany — not just at the international connection point.",
        tip: "If you are connecting through another U.S. hub to fly internationally, you need a valid passport at check-in at Albany. Many Greene County travelers discover expired passports at the ALB counter, not at the international hub.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF — Stewart International Airport",
        subtitle: "45 miles south, direct Dublin flights",
        description: "Stewart International in New Windsor is an alternative for Catskill travelers, especially for the direct Dublin route and domestic connections. SWF is slightly closer than ALB for southern Greene County residents. The airport's smaller size means fewer crowds but also fewer flight options — making passport readiness even more critical when your itinerary depends on a specific connection.",
        tip: "SWF's direct Dublin flight is the closest international departure to Catskill. Book the flight, then check your passport the same day — the one daily Dublin departure leaves no room for error.",
      },
      {
        icon: "ri-snowy-line",
        title: "Ski Season: Catskills to Alps Pipeline",
        subtitle: "Hunter, Windham, and Belleayre skiers heading to Europe",
        description: "The Catskill Mountains are home to some of the Northeast's most popular ski destinations — Hunter Mountain, Windham Mountain, and Belleayre Ski Resort. The region's ski culture creates a direct pipeline to the Alps: Catskill skiers booking trips to Zermatt, Chamonix, St. Anton, and Cortina. European ski resort bookings open 6–12 months in advance, but passport checks typically happen only weeks before departure — creating a seasonal passport urgency pattern unique to mountain towns.",
        tip: "Check your passport validity the day you book your Alps ski trip — not when you pull your ski bag out of storage. European ski resorts require 3 months of passport validity beyond your planned return date under Schengen rules.",
      },
      {
        icon: "ri-landscape-line",
        title: "Summer Mountain Tourism & International Visitors",
        subtitle: "Catskill Park, Kaaterskill Falls, mountain culture",
        description: "Summer transforms the Catskills into a major tourism destination, drawing visitors from around the world to Kaaterskill Falls, North-South Lake, and the Catskill Park's 700,000 acres. Many Catskill residents work in the seasonal tourism industry and travel internationally during the shoulder seasons (May and October). The compressed tourism season means passport urgencies cluster around April (pre-summer) and September (post-summer) as hospitality workers prepare for international travel.",
        tip: "Seasonal tourism workers should apply for or renew passports during the winter off-season (January–March) when acceptance facility appointments are easier to book and processing times are faster.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Catskill & the Hudson River School Legacy",
      description: "Catskill is where the Hudson River School of landscape painting was born — Thomas Cole's home and studio sit just across the Rip Van Winkle Bridge. This artistic heritage creates ongoing international connections: European art tourists visiting Cole's studio, Catskill artists traveling to European residencies and exhibitions, and cultural exchange programs that require passports on academic and institutional timelines.",
    },
  },
  destinations: {
    title: "Where Catskill Travelers Go — And Why Passports Get Urgent",
    intro: "The Catskill Mountain ski culture and Greene County's tourism economy create unique international travel patterns. Here are the most common destinations and urgency patterns.",
    stats: [
      { stat: "25%", label: "of Catskill expedited requests are ski-season-related with Alps departures November through February" },
      { stat: "100 Miles", label: "from Catskill to the nearest passport agency in Manhattan" },
      { stat: "Nov–Feb", label: "peak season when ski trips to Europe and winter holiday travel coincide" },
      { stat: "3 Days", label: "shortest turnaround we have accommodated for a Windham skier departing for Switzerland" },
    ],
    destinations: [
      { name: "Switzerland", context: "Zermatt, St. Moritz, Verbier ski destinations, Catskill-to-Alps ski culture, mountain resort travel", urgency: "Ski resort bookings confirmed 6–12 months in advance — passport checked 2–4 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "France", context: "Chamonix and Val d'Isère ski resorts, Paris cultural travel, Hudson River School art connections", urgency: "French Alps ski packages booked months ahead with fixed arrival dates at chalets", icon: "ri-map-pin-2-line" },
      { name: "Austria", context: "St. Anton, Kitzbühel, and Innsbruck ski destinations, Tyrolean Alps, mountain culture travel", urgency: "Austrian ski areas popular with Catskill skiers for terrain variety and snow reliability", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Cortina and Dolomites ski resorts, Milan and Rome cultural tourism, heritage travel", urgency: "Italian ski season December through March with fixed hotel and guide bookings", icon: "ri-map-pin-2-line" },
      { name: "Ireland", context: "SWF Dublin direct route, Irish heritage tourism, family reunions, Greene County diaspora connections", urgency: "Dublin flights booked 2–3 months out with passport check often delayed", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Quebec ski destinations (Mont-Tremblant, Mont-Sainte-Anne), Montreal cultural travel, cross-border trips", urgency: "Cross-border ski trips booked 1–2 months out with passport card or book required", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley & Catskill Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley, Catskills, and New York State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Hudson", route: "/cities/hudson-ny" },
      { name: "Kingston", route: "/cities/kingston" },
      { name: "Rhinebeck", route: "/cities/rhinebeck" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Catskill", address: "320 W Bridge Street, Catskill, NY 12414", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Hudson", address: "160 Fairview Avenue, Hudson, NY 12534", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Catskill Post Office", address: "1 Jefferson Avenue, Catskill, NY 12414", hours: "Mon–Fri 9 AM – 5 PM, Sat 9 AM – 12 PM", website: "https://tools.usps.com/find-location.htm" },
    { name: "Rite Aid — Catskill", address: "55 Maple Avenue, Catskill, NY 12414", hours: "Call for hours", website: "https://www.riteaid.com/photo" },
    { name: "The UPS Store — Hudson", address: "351 Fairview Avenue, Hudson, NY 12534", hours: "Mon–Fri 9 AM – 7 PM, Sat 10 AM – 3 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Saugerties", address: "330 Route 212, Saugerties, NY 12477", hours: "Daily 8 AM – 9 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Albany", address: "1475 Western Avenue, Albany, NY 12203", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 10 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart Supercenter — Catskill", address: "30 Catskill Commons, Catskill, NY 12414", hours: "Daily 6 AM – 11 PM", website: "https://www.walmart.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Catskill",
      address: "411 West Bridge Street, Catskill, NY 12414",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Catskill DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended during ski season.",
      featured: true,
    },
    {
      name: "NYS DMV — Hudson",
      address: "560 Warren Street, Hudson, NY 12534",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Hudson DMV office serving Columbia County and west Greene County residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "Approximately 50 miles north of Catskill",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with domestic flights and seasonal international connections. Most convenient for Greene County travelers connecting to international hubs.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: true,
    },
    {
      code: "SWF",
      name: "Stewart International Airport",
      distance: "Approximately 45 miles south of Catskill",
      address: "1 1st Street, New Windsor, NY 12553",
      note: "Regional airport with direct Dublin flights and domestic connections. Convenient for southern Greene County residents.",
      flightUrl: "https://www.swfny.com/",
      flightLabel: "Stewart Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records. Online, mail, or in-person options for Greene County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS Department of Health Vital Records. Required for estate and legal matters in Greene County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Greene County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.greenegovernment.com/departments/county-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Greene County Clerk. Required for name change passport corrections.",
      url: "https://www.greenegovernment.com/departments/county-clerk",
    },
  ],
};

export default catskillConfig;